// extracted by mini-css-extract-plugin
export var buttons = "_bs-0";
export var buttonsActive = "_bs-h";
export var cancelConfirm = "_bs-1";
export var closeButton = "_bs-2";
export var column = "_bs-3";
export var container = "_bs-4";
export var detailHeader = "_bs-6";
export var detailTitle = "_bs-7";
export var detailsContent = "_bs-5";
export var header = "_bs-8";
export var headerWithClose = "_bs-9";
export var icon = "_bs-a";
export var infoIcon = "_bs-c";
export var informationContainer = "_bs-b";
export var sideDrawer = "_bs-d";
export var sideDrawerOpen = "_bs-e";
export var stickyFooter = "_bs-f";
export var typeOption = "_bs-g";